import { render, staticRenderFns } from "./NoData.vue?vue&type=template&id=6d75517e&scoped=true&v-once=true&functional=true&"
var script = {}
import style0 from "./NoData.vue?vue&type=style&index=0&id=6d75517e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "6d75517e",
  null
  
)

export default component.exports